import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { rootRoute } from '../../../config';
import time_elapse_icon from '../../../assets/time_elapse_icon.png';
import info from '../assets/info.png';
// import Button from './Button';
import Button from '../../common/Button'
import ImModuleStyle from '../styles/im.module.css';

const SimProgress = ({ popupState, actions }) => {
  const navigate = useNavigate();
  const [timeoutId, setTimeoutId] = useState(0);
  const [playSimulation, resumeSimulation, pauseSimulation, toggleSimulation, setToggleSimulation,isShowPlaceOrder] = actions;
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, simObj, setSimObj, getMonth, isLoader, setIsLoader, setError, error,isRequestLoading] = popupState;
  const [currentTime, setCurrentTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const intervalDuration = 10; // 1 second in milliseconds
  const totalTime = 100; // Total time in seconds
  const closePopup = () => {
    setSimPrgPopup(false);
    setSimPopup(true);
  }
  const isLeapYear = (year) => {
    return ((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)) ? 366 : 365;
  }
  const progressbar = { "valuemin": 0, "valuemax": isLeapYear(simObj?.laststate?.stateyear), "valuenow": function () { return (Math.round((simObj.currentstep / this.valuemax) * 100)) } }
  const showSummary = () => {
    setIsLoader(true);
    navigate(rootRoute + "/im/summary");
  }
  const getShortMonth = (month) => {
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"]
    return months[month - 1];
  }
  useEffect(()=>{((toggleSimulation) && simObj.status != 'COMPLETED' && error == null && currentTime == totalTime) && resumeSimulation();},[currentTime])
  useEffect(()=>{!isRequestLoading &&  setCurrentTime(0);},[isRequestLoading])
  useEffect(() => {
    let intervalId;
    if (isPlaying && currentTime < totalTime) {
      intervalId = setInterval(() => {
        setCurrentTime((prevTime) => prevTime + 1);
      }, intervalDuration);
    } else {
      clearInterval(intervalId);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [isPlaying, currentTime, totalTime]);

  useEffect(()=>{(toggleSimulation) ? setIsPlaying(true) : setIsPlaying(false);},[toggleSimulation]);
  useEffect(() => {
    if (document.querySelector(`[class ="${ImModuleStyle.simProg}"]`) != null && window.innerWidth > 991) {
      let top = 0;
      if (document.querySelector(`.${ImModuleStyle['sim-progress-activity']} .${ImModuleStyle.posuccess}`) != null) {
        // top = document.querySelector(`.${ImModuleStyle._progress}`).clientHeight + document.querySelector(`.${ImModuleStyle.posuccess}`).clientHeight+12;
        top = 100;
        document.querySelector(`.${ImModuleStyle.simProg}`).style.top = top + "%";
      }
      else {
        top = document.querySelector(`.${ImModuleStyle._progress}`).clientHeight + document.querySelector(`.${ImModuleStyle._progress}`).offsetTop;
        document.querySelector(`.${ImModuleStyle.simProg}`).style.top = top + "px";
      }
    }
    if (document.querySelector(`.${ImModuleStyle['sim-progress-activity']} .${ImModuleStyle.posuccess}`) != null && window.innerWidth < 991 && document.querySelector(`.${ImModuleStyle.simProg}`) != null) {
      document.querySelector(`.${ImModuleStyle.ui}.${ImModuleStyle.pointing}.${ImModuleStyle.label}.${ImModuleStyle.simProg}`).style.left = "20%";
    }
  }, [simPrgPopup]);
  useEffect(()=>{
    if((simObj.status == 'COMPLETED') && (document.getElementById("showSummary") != null)){
      document.getElementById("showSummary").focus();
    }
  },[simObj.status])
  return (
    <div className={`${ImModuleStyle['sim-progress-activity']}`}>
      <div className={`${ImModuleStyle.pie}`} title={`${currentTime}% completed.`} style={{ '--p': (simObj.status == 'COMPLETED') ? 100 : currentTime, '--b': '10px', '--c': 'purple' }} role='progressbar' aria-valuetext={`${progressbar.valuenow()}%`}></div>
      <div className={`${ImModuleStyle._progress} ${simPrgPopup ? `show ${ImModuleStyle.show}` : ''}`}>
        <div className={`${ImModuleStyle['time-progress']}`}>
          <div className={`${ImModuleStyle['remain-time']}`}>
            {/* <img className={(toggleSimulation && simObj.status != 'COMPLETED') ? `${ImModuleStyle.spin}` : ''} src={time_elapse_icon} alt="" /> */}
            <span><strong>{getShortMonth(simObj?.laststate?.statemonth)} {simObj?.laststate?.stateday} </strong>({simObj?.laststate?.daysleft} days remaining)</span>
          </div>
          <div className={`ui progress indicating ${ImModuleStyle.progress} ${ImModuleStyle.ui}`}>
            <div className={`${ImModuleStyle['background']}`} id="time">
              <div role="progressbar"
                aria-valuenow={progressbar.valuenow()}
                aria-valuemin={progressbar.valuemin}
                aria-valuemax={progressbar.valuemax}
                aria-valuetext={`${progressbar.valuenow()}%`}
                className={` ${ImModuleStyle['progress-fg']} ${(toggleSimulation && simObj.status != 'COMPLETED') ? `${ImModuleStyle.active}` : ''}`} style={{ "width": progressbar.valuenow() + '%' }}></div>
            </div>
          </div>
        </div>
        {
          (toggleSimulation && simObj.status != 'COMPLETED') && <Button btnName="Pause Simulation" clickEventHandler={pauseSimulation} btnId="pauseSumButton" />
        }{
          (!toggleSimulation && simObj.status != 'COMPLETED') && <Button disabled={(simObj.laststate?.quantityordered == 0 && simObj?.currentstep == 0) ? true : false} btnName={simObj.currentstep == 0 ? 'Start Simulation' : 'Resume Simulation'} clickEventHandler={playSimulation} btnId="playSumButton" />
        }{
          (simObj.status == 'COMPLETED') && <Button btnName="Show Summary" clickEventHandler={showSummary} btnId="showSummary" />
        }

      </div>
      <div className={`${ImModuleStyle['simmsg-container']}`}>
        {
          (((toggleSimulation && simObj.status != 'COMPLETED' && simObj?.currentstep != 2) && !isShowPlaceOrder) || (!(toggleSimulation && simObj.status != 'COMPLETED') && isShowPlaceOrder) || (!(toggleSimulation && simObj.status != 'COMPLETED') && !isShowPlaceOrder && (simObj.status == 'COMPLETED'))) && <div className={`ui success message ${ImModuleStyle.ui} ${ImModuleStyle.success} ${ImModuleStyle.message} ${ImModuleStyle.simmsg}`}>
            <div role='alert'>
              <img src={info} alt="info" />
              {
                (toggleSimulation && simObj.status != 'COMPLETED') && <p>Pause the simulation to make a new decision.</p>
              }
              {
                isShowPlaceOrder && <p className='placeorder-msg'>{`Your order is placed, please click on ${simObj?.currentstep > 0 ? 'Resume' : 'Start'} Simulation to continue.`}</p>
              }
              {
                (simObj.status == 'COMPLETED') && <p>{`Simulation is completed! Please click on "Show Summary" to view report.`}</p>
              }
            </div>
          </div>
        }
        {
            (simObj?.status != 'COMPLETED' && simObj?.currentstep == 2) ? <div className={`ui success message ${ImModuleStyle.ui} ${ImModuleStyle.success} ${ImModuleStyle.message} ${ImModuleStyle.simmsg}`}>
                  <div role='alert'>
                    {
                      (<><img src={info} alt="info" /><p>{`Simulation is started.`}</p></>)
                    }
                  </div>
            </div> : ''
              
        }
      </div>
      {
        simPrgPopup ? <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['simProg']}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Simulation progress popup">
          <p>If you need to take a break or want more time to review your documents or place an order, Pause the Simulation to stop the days from passing.</p>
          <div className={`${ImModuleStyle.mt10} ${ImModuleStyle.dflex}`}>
            <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
            <Button btnName="Next" btnParentClassName={`${ImModuleStyle.ml10}`} btnId="btnNext1" btnWidth="80" clickEventHandler={closePopup} />
          </div>
        </div> : ''
      }
    </div>
  )
}

export default SimProgress